import * as API from '../../../api'
import {ReportType} from '../../../types/report-type'
import {LojasRelacionamentoType, restoreLojasFilters} from '../lojasRelacionamento'
import {REPORT_DEFINITIONS} from './reportDefinitions'

export type ReportFilters = Record<string, any>
export type ReportDataset = {columns: string[]; rows: unknown[][]; total: number | null}
export type ReportDatasets = Record<string, ReportDataset>

export function requestReport(
  type: ReportType,
  filters: ReportFilters,
  exportFile: boolean,
  limit: number
) {
  const definition = REPORT_DEFINITIONS[type]
  return definition.transport === 'relationship'
    ? API.getLojasRelacionamentoReport(
        restoreLojasFilters(filters),
        definition.apiType as LojasRelacionamentoType,
        exportFile,
        limit
      )
    : API.getReport(filters, definition.apiType, exportFile, limit)
}

function dataset(response: any): ReportDataset {
  if (
    !response?.success ||
    !Array.isArray(response.columns) ||
    !response.columns.every((column: unknown) => typeof column === 'string') ||
    !Array.isArray(response.data) ||
    !response.data.every(Array.isArray)
  ) {
    throw new Error('REPORT_LOAD_FAILED')
  }
  const count = response.counter == null || response.counter === '' ? NaN : Number(response.counter)
  return {
    columns: [...response.columns],
    rows: response.data,
    total: Number.isFinite(count) && count >= 0 ? count : null,
  }
}

export function reportDatasets(type: ReportType, response: any): ReportDatasets {
  if (!response?.success) throw new Error('REPORT_LOAD_FAILED')
  const tabs = REPORT_DEFINITIONS[type].tabs
  return tabs.length
    ? Object.fromEntries(tabs.map((tab) => [tab.id, dataset(response[tab.id])]))
    : {principal: dataset(response)}
}
